import { combineReducers } from '@reduxjs/toolkit'
import affiliate from './affiliateSlice';

const reducer = combineReducers({
    affiliate
})

export default reducer